// A person's avatar: their profile photo, or their initials on the brand circle
// when they have none (or it fails to load). Used by the profile card, the header
// pill, Settings → Users and the user panel (Oct 14 2026).
import { useState } from "react";

const SIZES = {
  xs: "w-5 h-5 text-xs",
  sm: "w-8 h-8 text-xs",
  md: "w-10 h-10 text-sm",
  lg: "w-14 h-14 text-lg",
};

export function initialsFor(user) {
  const source = user?.name || user?.email || "";
  const parts = source.replace(/@.*/, "").split(/[\s._-]+/).filter(Boolean);
  return parts.slice(0, 2).map((p) => p[0].toUpperCase()).join("") || "?";
}

export default function UserAvatar({ user, size = "md", className = "" }) {
  const [broken, setBroken] = useState(null);
  const url = user?.photo_url;
  const sizeCls = SIZES[size] || SIZES.md;
  if (url && broken !== url) {
    return (
      <img
        src={url}
        alt=""
        className={`${sizeCls} rounded-full object-cover shrink-0 bg-surface-inset ${className}`}
        onError={() => setBroken(url)}
      />
    );
  }
  return (
    <span
      className={`${sizeCls} rounded-full bg-brand-600 text-white font-semibold flex items-center justify-center shrink-0 ${className}`}
      aria-hidden="true"
    >
      {initialsFor(user)}
    </span>
  );
}
